export default "__VITE_ASSET__HJaCYbwmD7KReIZj8tQ72A__"